import KeyMirror from 'keymirror'

export const GREEN_FITOUT_STATUS = KeyMirror({
  DRAFT: null,
  UNDER_REVIEW: null,
  COMPLETED: null,
  CANCEL: null,
})

export const GREEN_FITOUT_FOLDER_TOGGLE_STATUS = KeyMirror({
  EXPAND: null,
  EXPAND_N_COLLAPSE: null,
  COLLAPSE: null,
})

export const GREEN_FITOUT_FOLDER_STATUS = KeyMirror({
  DRAFT: null,
  ACCEPTED: null,
  REJECTED: null,
  COMPLETED: null,
})

export const GREEN_FITOUT_FOLDER_ACTIONS = KeyMirror({
  REJECT: null,
  APPROVE: null,
  UPDATE_POINTS: null,
})

export const GREEN_FITOUT_HISTORY_TYPE = KeyMirror({
  SUBMISSION: null,
  GUIDELINE: null,
})

export const GREEN_FITOUT_HISTORY_ACTION_TYPE = KeyMirror({
  ADD_FORDER: null,
  SEND: null,
  RESEND: null,
  NEXT_REVIEWER: null,
  RECEIVERS: null,
  UPDATE: null,
  ADD: null,
  ON_HOLD: null,
  START_LETTER: null,
})

export const GREEN_FITOUT_DOCS_ACTION = KeyMirror({
  ADD: null,
  DELETE: null,
})

export const GREEN_INJECTION_KEYS = {
  ACTIVE_SUB_TAB: Symbol('GREEN_FITOUT_ACTIVE_SUB_TAB'),
}
export const GREEN_FITOUT_SUB_TAB = {
  COMMENT: Symbol('GREEN_FITOUT_SUB_COMMENT_TAB'),
  GUIDELINE: Symbol('GREEN_FITOUT_SUB_GUIDELINE_TAB'),
}
export const GREEN_FITOUT_SUB_TAB_MAP = {
  '1': GREEN_FITOUT_SUB_TAB.COMMENT,
  '2': GREEN_FITOUT_SUB_TAB.GUIDELINE,
}
